export default "__VITE_ASSET__8b058be6__"